import React from 'react';
import styles from './buttons.module.scss';

const Button = ({ type, children, className, onClick, title, isLoading, disabled, style }) => {
	return (
		<button
			className={`${styles.button} ${className ? className : ''} ${isLoading ? styles.loading : ''}`}
			type={type || 'button'}
			title={title}
			onClick={onClick}
			disabled={disabled || isLoading}
			style={style}
		>
			{children} {title}
		</button>
	);
};
export default Button;
